import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface UpcResponse {
  data: UpcData[];
  meta: {
    totalRowCount: number;
  };
}

export interface UpcData {
  id: number;
  upcId: string;
  email: string;
  name: string;
  doiCalculated: boolean;
  quantity: number;
  quantitySold: number;
  quantityInclusiveReturn: number;
  totalReturns: number;
  unitPrice: string;
  location: string;
  productName: string;
  createdAt: string;
  warehouse: Warehouse;
  updatedAt: string;
}

interface Warehouse {
  id: number;
}

interface UpcRequest {
  token: string;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const getAuditData = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: UpcRequest): Promise<UpcResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.WMS)}/wms/inventory/get-upc-data`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters,
          sorting: sorting,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getAuditData;
